import { render, staticRenderFns } from "./MagazineCreate.vue?vue&type=template&id=f6f9fd3a&"
import script from "./MagazineCreate.vue?vue&type=script&lang=js&"
export * from "./MagazineCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports